import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const SectionMeta = () => {
    const [meta, setMeta] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get('/sites/meta');
                const payload = response.data;

                setMeta(payload.data)
            } catch (error) {
                console.error('Error fetching meta:', error);
            }
        }

        fetchData();
    }, [])

    const defaultValues = {
        title: meta?.title,
        keywords: meta?.keywords,
        descript: meta?.descript,
        author: meta?.author
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,        
    } = useForm()

    useEffect(() => {        
        reset(defaultValues)
    }, [reset, meta])

    const onSubmit = async (data, e) => {
        const params = {
            "title": data.title,
            "keywords": data.keywords,
            "descript": data.descript,
            "author": data.author,
        };

        try {
            await apiService.put('/sites/meta', params);
            toast.success('업데이트 되었습니다.')
        } catch (error) {
            console.error('Error updating meta:', error);
        }
    }

    return (
        <Card>
            <CardHeader title='사이트 메타 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="sitemetaform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='title'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='제목'
                                            id='title'
                                            onChange={onChange}
                                            placeholder='사이트 제목를 입력해주세요'
                                            error={Boolean(errors.title)}
                                            aria-describedby='validation-async-title'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.title && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='author'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='저자 이름'
                                            id='author'
                                            onChange={onChange}
                                            placeholder='저자 이름을 입력해주세요'
                                            error={Boolean(errors.author)}
                                            aria-describedby='validation-async-author'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.author && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-author'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='keywords'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='keywords'
                                            rows={2}
                                            multiline
                                            id='keywords'
                                            onChange={onChange}
                                            placeholder='keywords를 입력해주세요'
                                            error={Boolean(errors.keywords)}
                                            aria-describedby='validation-async-keywords'
                                        />
                                    )}
                                />
                                {errors.keywords && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-keywords'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='descript'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='사이트 설명'
                                            rows={2}
                                            multiline
                                            id='descript'
                                            onChange={onChange}
                                            placeholder='사이트 설명를 입력해주세요'
                                            error={Boolean(errors.descript)}
                                            aria-describedby='validation-async-descript'
                                        />
                                    )}
                                />
                                {errors.descript && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-descript'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="sitemetaform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default SectionMeta
